import ContactService from "../services/ContactService";
import ContactApiService from "../services/ContactApiService";

class ContactViewModel {
  constructor() {
    this.contactService =  new ContactService();
    this.contactApiService = ContactApiService;
    this.contacts = [];
    this.groups = [];
    this.filteredContacts = [];
    this.filteredGroups = [];
    this.searchQuery = "";
    this.selectedTag = "All";
    this.selectedContacts = [];
    this.selectedGroups = [];
    this.onStateChange = null;
    this.isLoading = false;
    this.error = null;
    this.pagination = {
      page: 1,
      limit: 25,
      total: 0,
      totalPages: 0,
    };

    this.initializeData();
  }

  async initializeData() {
    try {
      await this.loadContacts();
    } catch (error) {
      console.error('Failed to initialize data:', error);
      // Ensure we have local data as fallback
      this.contacts = this.contactService.getAllContacts();
      this.filteredContacts = [...this.contacts];
      this.notifyStateChange();
    }
  }

  // Contact list management
  getContacts() {
    return this.filteredContacts;
  }
//   getContacts() {
//   return Array.isArray(this.filteredContacts)
//     ? this.filteredContacts
//     : [];
// }

  getGroups() {
    return this.filteredGroups;
  }

  getAllGroups() {
    return this.groups;
  }

  getContactById(contactId) {
    return this.contactService.getContactById(contactId);
  }

  // Search functionality
  async searchContacts(query) {
    this.searchQuery = query;
    try {
      await this.loadContacts({ search: query ,page: 1 });
    } catch (error) {
      // Fallback to local search
      this.applyFilters();
    }
    return this.filteredContacts;
  }

  getSearchQuery() {
    return this.searchQuery;
  }

  // Tag filtering
  async filterByTag(tag) {
    this.selectedTag = tag;
    try {
      await this.loadContacts({ tags: tag !== "All" ? tag : "",page: 1 });
    } catch (error) {
      // Fallback to local filter
      this.applyFilters();
    }
    return this.filteredContacts;
  }

  getSelectedTag() {
    return this.selectedTag;
  }

  getAllTags() {
    return this.contactService.getAllTags();
  }

  // Apply both search and tag filters
  applyFilters() {
    let filtered = [...this.contacts];

    // Apply tag filter
    if (this.selectedTag && this.selectedTag !== "All") {
      filtered = this.contactService.filterContactsByTag(this.selectedTag);
    }

    // Apply search filter
    if (this.searchQuery.trim() !== "") {
      const searchResults = this.contactService.searchContacts(
        this.searchQuery
      );
      filtered = filtered.filter((contact) =>
        searchResults.some((searchContact) => searchContact.id === contact.id)
      );
    }

    this.filteredContacts = filtered;
    this.notifyStateChange();
  }

  // Selection management
   async toggleContactSelection(contactId) {
    await this.contactService.toggleContactSelection(contactId); 
    this.updateSelectedContacts();
    this.notifyStateChange();
  }

  updateSelectedContacts() {
    this.selectedContacts = this.contactService.getSelectedContacts();
  }

  getSelectedContacts() {
    return this.selectedContacts;
  }

  getSelectedContactsCount() {
    return this.selectedContacts.length;
  }

  clearSelection() {
    this.contactService.clearSelection();
    this.selectedContacts = [];
    this.notifyStateChange();
  }

  selectAllContacts() {
    // Select all contacts that are currently visible (filtered contacts)
    this.filteredContacts.forEach((contact) => {
      contact.isSelected = true;
    });
    this.updateSelectedContacts();
    this.notifyStateChange();
  }

  // API Methods
  // async loadContacts(params = {}) {
  //   this.setLoading(true);
  //   this.setError(null);

  //   try {
  //     const apiParams = {
  //       page: params.page || this.pagination.page,
  //       limit: params.limit || this.pagination.limit,
  //       search: params.search || this.searchQuery,
  //       tags:
  //         params.tags || (this.selectedTag !== "All" ? this.selectedTag : ""),
  //       sortBy: params.sortBy || "created_at",
  //       sortOrder: params.sortOrder || "desc",
  //     };

  //     const response = await this.contactApiService.getContactsDetails(apiParams);

  //     if (response.success) {
  //       this.contacts = response.data.contacts;
  //       this.filteredContacts = [...this.contacts];
  //       this.pagination = {
  //         page: response.data.page,
  //         limit: response.data.limit,
  //         total: response.data.total,
  //         totalPages: Math.ceil(response.data.total / response.data.limit),
  //       };
  //       this.notifyStateChange();
  //     } else {
  //       console.log('API failed, falling back to local data:', response.error);
  //       // Fallback to local service if API fails
  //       this.loadLocalContacts(params);
  //     }
  //   } catch (error) {
  //     console.error("Load contacts error:", error);
  //     console.log('API error, falling back to local data');
  //     // Fallback to local service
  //     this.loadLocalContacts(params);
  //   } finally {
  //     this.setLoading(false);
  //   }
  // }
  async loadContacts(params = {}) {
  this.setLoading(true);
  this.setError(null);

  try {
    const apiParams = {
      page: params.page || this.pagination.page,
      limit: params.limit || this.pagination.limit,
      search: params.search || this.searchQuery,
      tag:
        params.tag || (this.selectedTag !== "All" ? this.selectedTag : " "),
      sortBy: params.sortBy || "created_at",
      sortOrder: params.sortOrder || "desc",
    };

    const response = await this.contactApiService.getContactsDetails(apiParams);

    // this.contacts = response.contacts;
    // this.filteredContacts = [...response.contacts];
     const contacts = response?.data?.contacts || [];

    this.contacts = contacts;
    this.filteredContacts = [...contacts];

    this.selectedContacts = [];
    this.contactService.clearSelection();
  
     this.pagination = {
      page: response?.data?.page || 1,
      limit: response?.data?.limit || 25,
      total: response?.data?.total || 0,
      totalPages: Math.ceil(
        (response?.data?.total || 0) / (response?.data?.limit || 25)
      ),
    };

    this.notifyStateChange();

  } catch (error) {
    console.error("Load contacts error:", error);
    this.loadLocalContacts(params);
  } finally {
    this.setLoading(false);
  }
}

  async loadGroups(params = {}) {
    this.setLoading(true);
    this.setError(null);

    try {
      const apiParams = {
        page: params.page || this.pagination.page,
        limit: params.limit || this.pagination.limit,
        search: params.search || this.searchQuery,
        tags:
          params.tags || (this.selectedTag !== "All" ? this.selectedTag : ""),
        sortBy: params.sortBy || "created_at",
        sortOrder: params.sortOrder || "desc",
      };

      const response = await this.contactApiService.getContactsDetails(apiParams);

      if (response.success) {
        this.contacts = response.data.contacts;
        this.filteredContacts = [...this.contacts];
        this.pagination = {
          page: response.data.page,
          limit: response.data.limit,
          total: response.data.total,
          totalPages: Math.ceil(response.data.total / response.data.limit),
        };
        this.notifyStateChange();
      } else {
        console.log('API failed, falling back to local data:', response.error);
        // Fallback to local service if API fails
        this.loadLocalContacts(params);
      }
    } catch (error) {
      console.error("Load contacts error:", error);
      console.log('API error, falling back to local data');
      // Fallback to local service
      this.loadLocalContacts(params);
    } finally {
      this.setLoading(false);
    }
  }

  loadLocalContacts(params = {}) {
    let localContacts = this.contactService.getAllContacts();
    
    // Apply search filter locally
    if (params.search || this.searchQuery) {
      const searchQuery = params.search || this.searchQuery;
      localContacts = this.contactService.searchContacts(searchQuery);
    }
    
    // Apply tag filter locally
    if (params.tags || (this.selectedTag && this.selectedTag !== "All")) {
      const tag = params.tags || this.selectedTag;
      localContacts = this.contactService.filterContactsByTag(tag);
    }
    
    this.contacts = this.contactService.getAllContacts(); // Keep all contacts for other operations
    this.filteredContacts = localContacts;
    this.pagination = {
      page: 1,
      limit: localContacts.length,
      total: localContacts.length,
      totalPages: 1,
    };
    this.notifyStateChange();
  }

  async createContact(contactData) {
    this.setLoading(true);
    this.setError(null);
    console.log('contactData', contactData);
    
    try {
      // Validate contact data
      const validationErrors = this.validateContactData(contactData);
      if (validationErrors.length > 0) {
        throw new Error(validationErrors.join(", "));
      }

      return this.contactApiService.createContact(contactData);

    } catch (error) {
      console.error("Create contact error:", error);
      this.setError(error.message);
      return { success: false, error: error.message };
    } finally {
      this.setLoading(false);
    }
  }

  async updateContact(contactId, contactData) {
    this.setLoading(true);
    this.setError(null);

    try {
      // Validate contact data
      const validationErrors = this.validateContactData(contactData);
      if (validationErrors.length > 0) {
        throw new Error(validationErrors.join(", "));
      }

      const response = await this.contactApiService.updateContact(
        contactId,
        contactData
      );

      if (response.success) {
        const updatedContact = response.data;

        // Update in local arrays
        const contactIndex = this.contacts.findIndex((c) => c.id === contactId);
        if (contactIndex !== -1) {
          this.contacts[contactIndex] = updatedContact;
        }

        const filteredIndex = this.filteredContacts.findIndex(
          (c) => c.id === contactId
        );
        if (filteredIndex !== -1) {
          this.filteredContacts[filteredIndex] = updatedContact;
        }

        this.notifyStateChange();
        return {
          success: true,
          data: updatedContact,
          message: response.message,
        };
      } else {
        this.setError(response.error);
        return {
          success: false,
          error: response.error,
          details: response.details,
        };
      }
    } catch (error) {
      console.error("Update contact error:", error);
      this.setError(error.message);
      return { success: false, error: error.message };
    } finally {
      this.setLoading(false);
    }
  }

  async deleteContact(contactId) {
    this.setLoading(true);
    this.setError(null);

    try {
      const response = await this.contactApiService.deleteContact(contactId);

      if (response.success) {
        // Remove from local arrays
        this.contacts = this.contacts.filter((c) => c.id !== contactId);
        this.filteredContacts = this.filteredContacts.filter(
          (c) => c.id !== contactId
        );
        this.updateSelectedContacts();
        this.notifyStateChange();
        return { success: true, message: response.message };
      } else {
        this.setError(response.error);
        return {
          success: false,
          error: response.error,
          details: response.details,
        };
      }
    } catch (error) {
      console.error("Delete contact error:", error);
      this.setError(error.message);
      return { success: false, error: error.message };
    } finally {
      this.setLoading(false);
    }
  }

  async deleteSelectedContacts() {
    this.setLoading(true);
    this.setError(null);

    try {
      const selectedIds = this.selectedContacts.map((contact) => contact.getId());
      const response = await this.contactApiService.deleteContacts(selectedIds);

      if (response.success) {
        // Remove from local arrays
        this.contacts = this.contacts.filter(
          (c) => !selectedIds.includes(c.getId())
        );
        this.filteredContacts = this.filteredContacts.filter(
          (c) => !selectedIds.includes(c.getId())
        );
        this.selectedContacts = [];
        this.notifyStateChange();
        return { success: true, message: response.message };
      } else {
        this.setError(response.error);
        return {
          success: false,
          error: response.error,
          details: response.details,
        };
      }
    } catch (error) {
      console.error("Delete selected contacts error:", error);
      this.setError(error.message);
      return { success: false, error: error.message };
    } finally {
      this.setLoading(false);
    }
  }

  // Local fallback methods (for offline/fallback scenarios)
  addContactLocal(contactData) {
    const newContact = this.contactService.addContact(contactData);
    this.contacts.push(newContact);
    this.applyFilters();
    this.notifyStateChange();
    return newContact;
  }

  updateContactLocal(contactId, contactData) {
    const updatedContact = this.contactService.updateContacts(
      contactId,
      contactData
    );
    if (updatedContact) {
      // Update in local arrays
      const contactIndex = this.contacts.findIndex((c) => c.id === contactId);
      if (contactIndex !== -1) {
        this.contacts[contactIndex] = updatedContact;
      }

      const filteredIndex = this.filteredContacts.findIndex(
        (c) => c.id === contactId
      );
      if (filteredIndex !== -1) {
        this.filteredContacts[filteredIndex] = updatedContact;
      }
    }
    this.notifyStateChange();
    return updatedContact;
  }

  // deleteContact(contactId) {
  //   const success = this.contactService.deleteContacts(contactId);
  //   if (success) {
  //     this.contacts = this.contactService.getAllContacts();
  //     this.applyFilters();
  //     this.updateSelectedContacts();
  //     this.notifyStateChange();
  //   }
  //   return success;
  // }

  // deleteSelectedContacts() {
  //   const selectedIds = this.selectedContacts.map((contact) => contact.id);
  //   selectedIds.forEach((id) => {
  //     this.contactService.deleteContacts(id);
  //   });
  //   this.contacts = this.contactService.getAllContacts();
  //   this.applyFilters();
  //   this.selectedContacts = [];
  //   this.notifyStateChange();
  // }

  // Contact statistics
  getTotalContactsCount() {
    return this.contacts.length;
  }

  getFilteredContactsCount() {
    return this.filteredContacts.length;
  }

  // Utility methods
  validateContactData(contactData) {
    const errors = [];

    if (!contactData.getName() || contactData.getName().trim() === "") {
      errors.push("Name is required");
    }

    if (!contactData.getPhoneNumber() || contactData.getPhoneNumber().trim() === "") {
      errors.push("Phone number is required");
    }

    if (contactData.getEmail() && !this.isValidEmail(contactData.getEmail())) {
      errors.push("Invalid email format");
    }

    return errors;
  }

  isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  isValidPhone(phone) {
    const phoneRegex = /^\+?[\d\s\-()]+$/;
    return phoneRegex.test(phone);
  }

  // Export functionality
  exportContacts(format = "json") {
    const dataToExport =
      this.selectedContacts.length > 0 ? this.selectedContacts : this.contacts;

    switch (format.toLowerCase()) {
      case "csv":
        return this.exportToCSV(dataToExport);
      case "json":
      default:
        return JSON.stringify(dataToExport, null, 2);
    }
  }

  exportToCSV(contacts) {
    const headers = ["Name", "Phone", "Email", "Tags"];
    const csvContent = [
      headers.join(","),
      ...contacts.map((contact) =>
        [
          `"${contact.name}"`,
          `"${contact.phone}"`,
          `"${contact.email || ""}"`,
          `"${contact.tags.join(", ") || ""}"`,
        ].join(",")
      ),
    ].join("\n");

    return csvContent;
  }

  // State change notification
  // Helper methods for loading and error states
  setLoading(loading) {
    this.isLoading = loading;
    this.notifyStateChange();
  }

  setError(error) {
    this.error = error;
    this.notifyStateChange();
  }

  clearError() {
    this.error = null;
    this.notifyStateChange();
  }

  getLoadingState() {
    return this.isLoading;
  }

  getError() {
    return this.error;
  }

  getPagination() {
    return this.pagination;
  }

  // Pagination methods
  async loadNextPage() {
    if (this.pagination.page < this.pagination.totalPages) {
      await this.loadContacts({ page: this.pagination.page + 1 });
    }
  }

  async loadPreviousPage() {
    if (this.pagination.page > 1) {
      await this.loadContacts({ page: this.pagination.page - 1 });
    }
  }

  async loadPage(page) {
    if (page >= 1 && page <= this.pagination.totalPages) {
      await this.loadContacts({ page });
    }
  }

  // Refresh data
  async refreshContacts() {
    await this.loadContacts();
  }

  // Force load local data (for testing when API is not available)
  loadLocalDataOnly() {
    this.loadLocalContacts();
  }

  notifyStateChange() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  }
}

export default ContactViewModel;
